import { render, staticRenderFns } from "./scenery-box-qing.vue?vue&type=template&id=fa34ac58&scoped=true&"
import script from "./scenery-box-qing.vue?vue&type=script&lang=js&"
export * from "./scenery-box-qing.vue?vue&type=script&lang=js&"
import style0 from "./scenery-box-qing.vue?vue&type=style&index=0&id=fa34ac58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa34ac58",
  null
  
)

export default component.exports